import { Location } from "src/api-service";

// **************************************************************************
// LOCATION STATE
// **************************************************************************
export interface LocationState {
    location: Location | null;
    locations: Location[];
    locationsLoading: boolean;
}

export const initialLocationState: LocationState = {
    location: null,
    locations: [],
    locationsLoading: false,
};
